var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImg3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1498_5301)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1498_5301)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.6602 10.9503L20.6802 15.1303C19.8402 18.7403 18.1802 20.2003 15.0602 19.9003C14.5602 19.8603 14.0202 19.7703 13.4402 19.6303L11.7602 19.2303C7.59018 18.2403 6.30018 16.1803 7.28018 12.0003L8.26018 7.81026C8.46018 6.96026 8.70018 6.22026 9.00018 5.61026C10.1702 3.19026 12.1602 2.54026 15.5002 3.33026L17.1702 3.72026C21.3602 4.70026 22.6402 6.77026 21.6602 10.9503Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0583 19.8994C14.4383 20.3194 13.6583 20.6694 12.7083 20.9794L11.1283 21.4994C7.15839 22.7794 5.06839 21.7094 3.77839 17.7394L2.49839 13.7894C1.21839 9.81937 2.27839 7.71937 6.24839 6.43937L7.82839 5.91937C8.23839 5.78937 8.62839 5.67938 8.99839 5.60938C8.69839 6.21938 8.45839 6.95938 8.25839 7.80938L7.27839 11.9994C6.29839 16.1794 7.58839 18.2394 11.7583 19.2294L13.4383 19.6294C14.0183 19.7694 14.5583 19.8594 15.0583 19.8994Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4894 11.0195C17.4294 11.0195 17.3694 11.0095 17.2994 10.9995L12.4494 9.76954C12.0494 9.66954 11.8094 9.25954 11.9094 8.85954C12.0094 8.45954 12.4194 8.21954 12.8194 8.31954L17.6694 9.54954C18.0694 9.64954 18.3094 10.0595 18.2094 10.4595C18.1294 10.7895 17.8194 11.0195 17.4894 11.0195Z",
    fill: "#392C7D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5611 14.4006C14.5011 14.4006 14.4411 14.3906 14.3711 14.3806L11.4611 13.6406C11.0611 13.5406 10.8211 13.1306 10.9211 12.7306C11.0211 12.3306 11.4311 12.0906 11.8311 12.1906L14.7411 12.9306C15.1411 13.0306 15.3811 13.4406 15.2811 13.8406C15.2011 14.1806 14.9011 14.4006 14.5611 14.4006Z",
    fill: "#392C7D"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1498_5301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.509766)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1498_5301"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.509766)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImg3);
export default __webpack_public_path__ + "static/media/img3.7bb8d09b724c2873c33f98302876f22c.svg";
export { ForwardRef as ReactComponent };